enum ActionTypes {
  LOAD_RECIPE_DETAILS = 'RECIPE_DETAILS/LOAD',
  LOAD_RECIPE_DETAILS_SUCCESS = 'RECIPE_DETAILS/SUCCESS',
  LOAD_RECIPE_DETAILS_ERROR = 'RECIPE_DETAILS/ERROR'
}

export const RECIPE_TYPES = {
  ...ActionTypes
};
